import { useSearchParams } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { DEFAULT_ORGANIZATION_NAME, FOUNDER_FIRST_NAME } from "../config/vertical";

/**
 * Pantalla privada de entrega — lo primero que ve un Socio Fundador al
 * abrir la liga que Fernando le mandó por WhatsApp, ANTES de autenticarse.
 * No es la bienvenida de primer ingreso (esa sigue siendo Welcome.jsx,
 * después de entrar) — esta es el momento de "esto es tuyo", el que hace
 * que la liga se sienta como una entrega personal y no como un enlace
 * técnico de acceso.
 *
 * El token sigue viajando solo por la URL (igual que /login?t= hoy) —
 * nunca se imprime en texto visible ni queda hardcodeado en el bundle.
 * Esta pantalla solo lo recibe y lo reenvía al mismo intercambio de
 * siempre (token → cookie HttpOnly en el servidor) cuando el Socio
 * Fundador decide entrar.
 */
export default function FounderHandoff() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("t");
  const greetingName = FOUNDER_FIRST_NAME || "";

  if (!token) {
    return (
      <div className="min-h-screen bg-[#0d1321] text-zinc-100 flex items-center justify-center px-5 sm:px-8">
        <div className="max-w-md text-center">
          <div className="text-[11px] text-amber-500 font-mono uppercase tracking-[0.35em] mb-6">
            Commercial Operator
          </div>
          <p className="text-zinc-400 text-sm leading-relaxed">
            Este enlace no está completo. Pide a quien te lo compartió que
            te reenvíe la invitación.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0d1321] text-zinc-100 flex items-center justify-center px-5 sm:px-8">
      <div className="max-w-xl text-center">
        <div className="text-[11px] text-amber-500 font-mono uppercase tracking-[0.35em] mb-6">
          Commercial Operator
        </div>
        <h1 className="font-display font-black text-3xl sm:text-4xl md:text-5xl tracking-tight text-zinc-50 leading-tight">
          {greetingName ? `${greetingName}, ` : ""}tu Commercial Operator ya está listo.
        </h1>
        <p className="text-lg text-zinc-400 mt-5 leading-relaxed">
          Preparé tu Centro de Operaciones para que puedas cargar tu cartera,
          detectar renovaciones y empezar a trabajar oportunidades comerciales
          desde un solo lugar.
        </p>
        <p className="text-sm text-zinc-600 mt-3">
          {DEFAULT_ORGANIZATION_NAME}
        </p>
        <a
          href={`/login?t=${encodeURIComponent(token)}`}
          className="mt-10 w-full sm:w-auto inline-flex items-center justify-center gap-2 text-sm font-medium px-8 py-4 bg-amber-500 text-black hover:bg-amber-400 btn-glow-amber"
        >
          Entrar a mi Commercial Operator <ArrowUpRight size={16} />
        </a>
      </div>
    </div>
  );
}
